import React, { ComponentPropsWithoutRef } from 'react';
import LazyLoad from 'react-lazy-load';

export interface IImageProps extends ComponentPropsWithoutRef<'img'> {
  lazyLoadProps?: Omit<LazyLoad['props'], 'children'>;
}

const Image: React.FC<IImageProps> = ({ lazyLoadProps, ...props }) => {
  return (
    <LazyLoad {...lazyLoadProps}>
      <img {...props} />
    </LazyLoad>
  );
};

export default Image;
